'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: ', ';\n  font-style: italic;\n  align-self: flex-end;\n  cursor: pointer;\n  text-decoration: none;\n\n  span {\n    margin-right: 10px;\n  }\n'], ['\n  color: ', ';\n  font-style: italic;\n  align-self: flex-end;\n  cursor: pointer;\n  text-decoration: none;\n\n  span {\n    margin-right: 10px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _faCloudDownloadAlt = require('@fortawesome/free-solid-svg-icons/faCloudDownloadAlt');

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.a(_templateObject, _config.colors.red);

Button.displayName = 'Button';

var DownloadButton = function DownloadButton(_ref) {
  var file = _ref.file;
  return _react2.default.createElement(
    Button,
    {
      href: file,
      download: true
    },
    _react2.default.createElement(
      'span',
      null,
      'Download'
    ),
    _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faCloudDownloadAlt.faCloudDownloadAlt,
      'aria-hidden': 'true'
    })
  );
};

DownloadButton.propTypes = {
  /** a url for a file to be downloaded */
  file: _propTypes2.default.string.isRequired
};

DownloadButton.displayName = 'DownloadButton';

exports.default = DownloadButton;
DownloadButton.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'DownloadButton',
  'props': {
    'file': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'a url for a file to be downloaded'
    }
  }
};